import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { brand, nav } from '../data/site';
export function SiteNav() {
  const [solid, setSolid] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > window.innerHeight * 0.75);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const dark = solid || open;
  return <header className={`fixed inset-x-0 top-0 z-50 transition-colors duration-200 ease-out ${dark ? 'border-b border-ink/10 bg-cream/95 backdrop-blur' : ''}`} data-id="element-154" data-mp="2wmopxwqyhtze">
      <div className="mx-auto flex h-20 max-w-6xl items-center justify-between px-6" data-id="element-155" data-mp="2mqd8ytgf8fym">
        <a href="#top" aria-label={brand.name} className="flex items-center" data-id="element-156" data-mp="pxa3wsb4hwui">
          <img src={brand.logo} alt={brand.name} className={`h-8 w-auto transition-[filter] duration-200 ease-out ${dark ? '' : 'brightness-0 invert'}`} data-id="element-157" data-mp="ky6xb3fhvikf" />
        </a>

        <nav className="hidden items-center gap-9 md:flex" aria-label="Hoofdmenu" data-id="element-158" data-mp="dzgp5qbd4p0m">
          {nav.map(item => <a key={item.href} href={item.href} className={`text-sm transition-colors duration-150 ease-out ${dark ? 'text-ink/60 hover:text-ink' : 'text-cream/80 hover:text-cream'}`} data-id="element-159" data-mp="3v8n6dta026eb">
              {item.label}
            </a>)}
          <a href="#app" className={`rounded-full px-6 py-2.5 text-sm font-medium transition-colors duration-150 ease-out ${dark ? 'bg-ink text-cream hover:bg-clay' : 'bg-cream text-ink hover:bg-clay hover:text-cream'}`} data-id="element-160" data-mp="i0aemo4gebvm">
            Download app
          </a>
        </nav>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? 'Menu sluiten' : 'Menu openen'} className={`md:hidden ${dark ? 'text-ink' : 'text-cream'}`} data-id="element-161" data-mp="1fgzc65mderz7">
          {open ? <XIcon className="h-5 w-5" data-id="element-162" data-mp="1g9xbhpos6xmj" /> : <MenuIcon className="h-5 w-5" data-id="element-163" data-mp="1g95fidr9uxvq" />}
        </button>
      </div>

      {open && <div className="border-t border-ink/10 bg-cream px-6 py-4 md:hidden" data-id="element-164" data-mp="1bbdnljqmnbrj">
          {nav.map(item => <a key={item.href} href={item.href} onClick={() => setOpen(false)} className="block py-3 text-base text-ink/75" data-id="element-165" data-mp="16e3qrj0wrxto">
              {item.label}
            </a>)}
          <a href="#app" onClick={() => setOpen(false)} className="mt-3 block rounded-full bg-ink px-6 py-3 text-center text-sm font-medium text-cream" data-id="element-166" data-mp="slxjynjnb36w">
            Download app
          </a>
        </div>}
    </header>;
}